import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1094.33497,415.47137 L1094.33497,689.055113 L683.959359,689.055113 L683.959359,1920.18196 L410.375615,1920.18196 L410.375615,689.055113 L0,689.055113 L0,415.47137 L1094.33497,415.47137 Z M1607.30449,5 C1733.28981,5 1849.83648,82.4241994 1897.57685,197.466164 C1945.454,312.781712 1915.63337,440.134944 1817.96398,537.804341 C1769.95003,585.818288 1713.1814,639.167118 1659.01182,688.959359 L1659.01182,688.959359 L1915.0862,688.959359 L1915.0862,962.543102 L1367.91872,962.543102 C1292.27281,962.543102 1231.12685,901.397136 1231.12685,825.751231 L1231.12685,825.751231 L1231.12685,765.973183 C1231.12685,726.30354 1248.36262,688.685775 1278.18325,662.69532 C1278.32688,662.561263 1279.50207,661.531713 1281.60889,659.687511 L1283.64055,657.909145 C1317.84371,627.96861 1504.66545,464.255455 1624.54027,344.380634 C1634.52608,334.394827 1650.39393,315.654341 1644.78547,302.111946 C1640.13454,290.75822 1624.54027,278.583744 1607.30449,278.583744 C1557.23867,278.583744 1497.59741,334.531619 1476.80505,361.61641 L1476.80505,361.61641 L1258.48522,196.645412 C1273.25874,176.947383 1407.86194,5 1607.30449,5 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextSuperscriptSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTextSuperscriptSolid, _Component);

  var _super = _createSuper(IconTextSuperscriptSolid);

  function IconTextSuperscriptSolid() {
    _classCallCheck(this, IconTextSuperscriptSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextSuperscriptSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextSuperscript",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextSuperscriptSolid.displayName = "IconTextSuperscriptSolid";
  return IconTextSuperscriptSolid;
}(Component);

IconTextSuperscriptSolid.glyphName = 'text-superscript';
IconTextSuperscriptSolid.variant = 'Solid';
IconTextSuperscriptSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextSuperscriptSolid;
export { IconTextSuperscriptSolid };